export default __webpack_public_path__ + "static/media/neweggca.5ec63d00.svg";